// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface LightbulbIconSignature {
  Element: SVGSVGElement;
}

export const LightbulbIcon: TOC<LightbulbIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C7.589 2 4 5.589 4 10C4 14.411 7.589 18 12 18C16.411 18 20 14.411 20 10C20 5.589 16.411 2 12 2ZM13 15.91V13.535L15.555 11.831L14.446 10.167L12 11.798L9.555 10.168L8.446 11.832L11 13.535V15.91C8.167 15.431 6 12.967 6 10C6 6.691 8.691 4 12 4C15.309 4 18 6.691 18 10C18 12.967 15.833 15.431 13 15.91ZM11 21H9V19H15V21H13V22H11V21Z"/>
</svg>
</template>;